<script setup lang="ts">
const { t } = useI18n()
const route = useRoute()
const goatUrl = import.meta.env.VITE_GOAT_SITE
const { getGameToken, GameKeyEnum } = gamesUtils
function manageAccount() {
  const tokenData = getGameToken(GameKeyEnum.goat)
  if (tokenData?.token && tokenData?.email) {
    const currentLocale = String(route.params?.locale || 'en')
    const params = new URLSearchParams({ goat_token: tokenData.token, goat_email: tokenData.email, flang: currentLocale })
    window?.open(`${goatUrl}?${params.toString()}`, '_blank', 'noopener,noreferrer')
  }
}
</script>

<template>
  <a
    :href="goatUrl"
    target="_blank"
    @click.prevent="manageAccount"
  >
    <el-button
      color="#2b7989"
      class="rounded-lg font-black bg-[#2b7989] hover:bg-[#3ba6bc]"
      size="large"
    >
      <div class="text-base uppercase">
        {{ t('goatManageAccountBtn.title') }}
      </div>
    </el-button>
  </a>
</template>

<style scoped lang="postcss">

</style>
